<template>
	<div class="absolute inset-0 grid size-full place-items-center">
		<slot />
	</div>
</template>
